(function () {
  function syncSearchTabs(searchPage) {
    if (!searchPage) return;
    var tabs = searchPage.querySelectorAll('[data-filter-tab]');
    var sections = searchPage.querySelectorAll('[data-results-section]');
    tabs.forEach(function (tab) {
      if (tab.dataset.tabBound === 'true') return;
      tab.dataset.tabBound = 'true';
      tab.addEventListener('click', function () {
        tabs.forEach(function (item) {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var filter = tab.dataset.filterTab;
        sections.forEach(function (section) {
          section.style.display = (filter === 'all' || section.dataset.resultsSection === filter) ? '' : 'none';
        });
      });
    });
  }

  function initAxiomSearch(root) {
    var scope = root && root.querySelector ? root : document;
    var searchPage = scope.querySelector('[data-search-page]') || document.querySelector('[data-search-page]');
    if (!searchPage) return;

    syncSearchTabs(searchPage);
    if (!window.AxiomFilterRenderer) return;

    window.AxiomFilterRenderer.init({
      scope: scope,
      rootSelector: '[data-search-page]',
      mainSelector: '.collection-main',
      activeLinkSelector: '.active-filters a[href], .drawer-clear[href]',
      afterRender: initAxiomSearch
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAxiomSearch(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAxiomSearch(event.target);
  });
})();
